import { getZonedDate } from '@eika-infrastruktur/date';
import { DownpaymentActionType } from './actions';
import { downpaymentInitialState } from './state';
const reducer = (state, action) => {
    switch (action.type) {
        case DownpaymentActionType.FROM_ACCOUNT_SELECTED:
            return {
                ...state,
                fromAccount: action.payload,
            };
        case DownpaymentActionType.TO_ACCOUNT_SELECTED:
            return {
                ...state,
                toAccount: action.payload,
            };
        case DownpaymentActionType.AMOUNT:
            return {
                ...state,
                amount: action.payload,
            };
        case DownpaymentActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case DownpaymentActionType.RESET:
            return {
                ...downpaymentInitialState,
            };
        case DownpaymentActionType.RESET_WITH_FROM_ACCOUNT:
            return {
                ...downpaymentInitialState,
                fromAccount: action.payload,
                paymentDate: getZonedDate(),
            };
        case DownpaymentActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case DownpaymentActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        case DownpaymentActionType.SHOW_TO_ACCOUNTS:
            return {
                ...state,
                showToAccounts: true,
            };
        case DownpaymentActionType.HIDE_TO_ACCOUNTS:
            return {
                ...state,
                showToAccounts: false,
            };
        default:
            return state;
    }
};
const downpaymentReducer = (state, action) => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cDownpayment form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};
export default downpaymentReducer;
//# sourceMappingURL=data:application/json;base64,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